import { useI18n } from '../i18n/I18nContext'

function Footer() {
  const { t } = useI18n()

  return (
    <>
      <footer className='footer'>
        <div className='footer-content-row'>
          <div className='logo-wrapper'>
            <img src='/images/logo.webp' alt={t('alt.logo')} />
          </div>

          <div className='delivery-info'>
            <div className='glovo-wrapper'>
              <a
                href='https://glovoapp.com/rs/sr/beograd/two-guys-smash-burger-beg/'
                rel='noreferrer'
                target={'_blank'}
              >
                {/* <p>Poručite i na Glovu!</p> */}

                <img src='/images/glovo.webp' alt={t('alt.glovo')} />
              </a>
            </div>

            <div className='glovo-wrapper'>
              <a
                href='https://wolt.com/sr/srb/belgrade/restaurant/two-guys-smash-burgers'
                rel='noreferrer'
                target={'_blank'}
              >
                {/* <p>Poručite i na Glovu!</p> */}

                <img src='/images/wolt.png' alt={t('alt.wolt')} />
              </a>
            </div>

            <div className='glovo-wrapper'>
              <a
                href='https://misterd.rs/place/two-guys-smash-burgers-dostava'
                rel='noreferrer'
                target={'_blank'}
              >
                {/* <p>Poručite i na Mister D!</p> */}

                <img src='/images/mrd.webp' alt={t('alt.misterD')} />
              </a>
            </div>
          </div>

          <div className='social-network-container'>
            <div className='social-network-images'>
              <div className='social-wrapper'>
                <a
                  href='https://www.facebook.com/profile.php?id=100090324897885'
                  rel='noreferrer'
                  target={'_blank'}
                >
                  <img src='/images/facebook.webp' alt={t('alt.facebook')} />
                </a>
              </div>
              <div className='social-wrapper'>
                <a
                  href='https://www.instagram.com/two_guys.bg/'
                  rel='noreferrer'
                  target={'_blank'}
                >
                  <img src='/images/insta.webp' alt={t('alt.instagram')} />
                </a>
              </div>
            </div>
            {/* <p>Posetite nas i na društvenim mrežama</p> */}
          </div>
        </div>
        <div className='footer-copyright'>
          {t('footer.copyright')}
        </div>
      </footer>
    </>
  )
}

export default Footer
